import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Spin, Modal } from 'antd'
import {withTranslation} from 'react-i18next'
import PhoneSearchForm from './PhoneSearchForm'
import PhoneSearchResult from './PhoneSearchResult'
@inject('intelligentOutboundCallStore')
@observer
class TemplateList extends Component {
  state = {
  }
  formRef = React.createRef()
  componentDidMount() {
  }
  render() {
    const { intelligentOutboundCallStore, addModalVisible, handleCancel, sourceType, isValid, t } = this.props
    const { isFetchingPhone } = intelligentOutboundCallStore
    return (
      <Modal
        title={t(`marketingManagement.phoneDetails`)}
        closable={true}
        visible={addModalVisible}
        onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose={true}
        width={'60%'}
        centered
        footer={false}
        className='shortLinkModel'
      >
        <Spin spinning={isFetchingPhone}>
          <PhoneSearchForm sourceType={sourceType} isValid={isValid} />
          <PhoneSearchResult sourceType={sourceType} handleCancel={handleCancel} />
        </Spin>
      </Modal>
    )
  }
}

export default withTranslation()(TemplateList)
